
/*
    wrapper for the BusOpsPage component for all trips combined,
    passes the data context information through to
    facilitate data reloads
*/

import React, {useContext} from "react";

import DataContext from "../DataContext";

import BusOpsPage from "./BusOpsPage";

const BusOpsAllPage = (props) => {
    const context = useContext(DataContext);

    // console.log("Busops ALL context", context);

    return (
        <BusOpsPage mode="ALL" {...props}
            dataReload={context.dataReload}
            setReload={context.setReload}
            showExternalChange={context.showExternalChange}
        />
    )
};

export default BusOpsAllPage;
